import Resource from '@/api/resources/Resource'

class ConfigurationDepartmentTypeServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/departmentTypes`, filterModel, { params })
        return response.data
    }
    async patchDepartmentTypesBatch(departmentTypes) {
        const response = await this.axios.patch(`/configuration/departmentTypes/batch`, departmentTypes)
        return response.data
    }
    async createDepartmentType(departmentTypes) {
        const response = await this.axios.post(`/configuration/departmentTypes`, departmentTypes)
        return response.data
    }
    async deleteDepartmentTypesBatch(departmentTypesIds) {
        const data = {
            entityIdentifiers: departmentTypesIds
        }
        const response = await this.axios.delete(`/configuration/departmentTypes/batch`, { data: data })
        return response.data
    }
}

export default new ConfigurationDepartmentTypeServices()
